<template>
  <div>
    <div
      v-if="ordersAreLoading"
      class="cf-flex cf-flex--column cf-flex--align-center cf-flex--justify-center cf-section-loader-container"
    >
      <div class="cf-loader" />
    </div>

    <div
      v-else
      class="cf-flex cf-flex--column cf-flex--gap-16 cf-phone-padding-16"
    >
      <div class="cf-flex cf-flex--column cf-flex--align-center cf-flex--gap-16">
        <div class="cf-flex cf-flex--column cf-flex--align-center">
          <img
            class="illustration illustration--chef illustration--white"
            src="/images/illustrations/chef-white.svg"
            alt=""
            role="presentation"
          >

          <img
            class="illustration illustration--chef illustration--black"
            src="/images/illustrations/chef-black.svg"
            alt=""
            role="presentation"
          >

          <h1 class="cf-title cf-title--3 cf-title--primary cf-text-align-center">
            Which order is yours?
          </h1>

          <p class="cf-subtitle cf-subtitle--2 cf-text-align-center">
            Please select your order at this table.
          </p>
        </div>

        <div class="container max-width-mobile">
          <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--justify-space-between">
            <h2 class="cf-title cf-title--6 cf-title--uppercase">
              Open Orders
            </h2>

            <p class="cf-title cf-title--6 cf-title--uppercase cf-title--regular">
              {{ userLocationType.description }}
              {{ tableNumberDisplay }}
            </p>
          </div>

          <ul class="item-list">
            <li
              v-for="order in orders"
              :key="order.orderId"
              class="item-list__item"
            >
              <div class="item-list__content-wrapper">
                <div class="item-list__header">
                  <h3 class="item-list__title">
                    Order #{{ order.ticketNumber }}
                  </h3>

                  <p class="item-list__price">
                    {{ $dollars(order.total) }}
                  </p>
                </div>

                <div class="cf-flex cf-flex--row cf-flex--justify-space-between">
                  <div class="item-list__description">
                    <p class="item-list__description-text">
                      <span
                        v-for="item in order.orderItems"
                        :key="item.lineItemId"
                        class="item-list__tag item-list__tag--block"
                      >
                        {{ item.itemDescription }}
                      </span>
                    </p>
                  </div>

                  <button
                    type="button"
                    class="cf-button cf-button--primary"
                    @click="selectOrder(order)"
                  >
                    Select
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import events from '@/services/events';
  import logger from '@/services/logger';
  import { mapGetters } from 'vuex';

  export default {
    name: 'PayAtTableSelectOrderPage',

    metaInfo() {
      return {
        title: 'Select Order'
      };
    },

    data() {
      return {
        ordersAreLoading: false
      };
    },

    computed: {
      ...mapGetters('orders', ['orders', 'tableNumberDisplay', 'userLocationType']),
      ...mapGetters('session', ['session'])
    },

    created() {
      this.createdHandler();
    },

    methods: {
      autoSelectSingleOrder() {
        if (this.orders.length === 1 && !this.$route.query.forceDisplay) {
          this.selectOrder(this.orders[0], true);
        }
      },

      createdHandler() {
        this.loadCurrentOrders();
      },

      handleNoOpenOrders() {
        let subtitle = 'There doesn\'t appear to be any open orders.';

        if (this.session.route.ticketNumber) {
          subtitle = `There doesn't appear to be an open order matching your check number: ${this.session.route.ticketNumber}`;
        }

        events.emit('full-page-message', {
          title: 'Oops!',
          subtitle,
          description: 'Please ask the waitstaff for assistance.',
          button: 'goToDefaultPage'
        });
      },

      async loadCurrentOrders() {
        this.ordersAreLoading = true;

        try {
          await this.$store.dispatch('orders/getAllOrdersAtTable');

          this.autoSelectSingleOrder();
        }

        catch (error) {
          logger.error(error);

          if (error.message === 'no open orders') {
            this.handleNoOpenOrders();
          }

          else {
            events.emit('full-page-message', {
              type: 'generic-p@t-error',
              button: 'goToDefaultPage'
            });
          }
        }

        finally {
          this.ordersAreLoading = false;
        }
      },

      selectOrder(order, autoSelected) {
        const route = {
          name: 'payAtTableCheckout',
          params: {
            merchantId: this.$route.params.merchantId
          },
          query: {
            /* set selected orderId query param in route */
            oi: order.orderId,

            /* retain existing route query params */
            cq: this.session.route.customQuery,
            ml: this.session.route.merchantLocationId,
            pl: this.session.route.posLocationId,
            st: this.session.route.sublocationToken,
            tn: this.session.route.ticketNumber
          }
        };

        if (autoSelected) {
          this.$store.dispatch('orders/cacheOrderSelection', order);
          this.$router.replace(route);
        }
        else {
          this.$router.push(route);
        }
      }
    }
  };
</script>
